/**
 *
 * QrScanner
 *
 */

import React, { memo, useState, useEffect } from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

// styles
import "./style.scss";

// global user
import { useAskPermissionOnDevice } from "engine/Contexts/User.context";
import {
  BarcodeScanner,
  SupportedFormat,
} from "@capacitor-community/barcode-scanner";
import { Button } from "antd";

function QrScanner({
  // default props
  getResult,
  className,
  ...rest
}) {
  const childClassNames = classNames("QrScanner-wrapper", className);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const onAskPermission = useAskPermissionOnDevice();

  useEffect(() => {
    BarcodeScanner.prepare();
    !loading && onAskPermission();
    return () => {
      document.body.classList.remove("qrscanner");
      BarcodeScanner.showBackground();
      BarcodeScanner.stopScan();
    };
  }, []);

  //console.debug("BarcodeScanner status", JSON.stringify(document.body.classList))

  const startScan = async () => {
    // Check camera permission
    // This is just a simple example, check out the better checks below
    document.body.classList.add("qrscanner");
    // console.debug("Check camera permission");
    await BarcodeScanner.hideBackground();
    // make background of WebView transparent
    // note: if you are using ionic this might not be enough, check below
    const status = await BarcodeScanner.checkPermission({ force: false });
    const result = await BarcodeScanner.startScan({
      targetedFormats: [SupportedFormat.QR_CODE],
    }); // start scanning and wait for a result
    if (result?.hasContent) {
      //console.debug("result.content", result.content); // log the raw scanned content
      stopScan();
      document.body.classList.remove("qrscanner");
      getResult(result.content);
    }
  };

  const stopScan = () => {
    BarcodeScanner.showBackground();
    BarcodeScanner.stopScan();
    document.body.classList.remove("qrscanner");
  };

  return (
    <div className={childClassNames}>
      <Button
        type="primary"
        htmlType="submit"
        block
        size="large"
        className="scan-submit"
        loading={loading}
        onClick={() => startScan()}
      >
        {t("components.scanQRButton")}
      </Button>
    </div>
  );
}

QrScanner.defaultProps = {};
QrScanner.propTypes = {};

export default memo(QrScanner);
